import { ServiceManager } from '@prisma/client';

import { routes } from '@/shared/routes';
import { ClientType } from '@/shared/types/enum';

import { modelId } from '@/front/actions/utils';
import { DELETE, POST } from '@/front/fetch';
import { getLookupPicker } from '@/front/lookupPicker';
import { alertModal } from '@/front/modal';

export const createServiceManager = async (type: ClientType, button: HTMLAnchorElement | HTMLButtonElement) => {
  const servicePicker = getLookupPicker('serviceManagerServicePicker');
  const userPicker = getLookupPicker('serviceManagerUserPicker');

  if (servicePicker && userPicker) {
    const organisationId = type === ClientType.Organisation ? modelId() : undefined;
    const individualId = type === ClientType.Individual ? modelId() : undefined;
    const serviceId = servicePicker?.value as string | undefined;
    const userId = userPicker?.value as string | undefined;

    if ((organisationId || individualId) && serviceId && userId) {
      const serviceManager: Partial<ServiceManager> = {
        organisationId,
        individualId,
        serviceId,
        userId,
      };

      const res = await POST(routes.serviceManagers.create(), serviceManager);

      if (res.ok) {
        button.closest('.table-like-row')?.insertAdjacentHTML('beforebegin', await res.text());
        servicePicker.value = '';
        userPicker.value = '';
      } else {
        const errorBody = await res.json().catch(() => null);
        const message = errorBody?.message ?? 'Failed to assign service manager.';
        alertModal(message);
      }
    }
  }
};

export const deleteServiceManager = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const id = button.dataset.value;

  if (id) {
    const res = await DELETE(routes.serviceManagers.edit({ id }));

    if (res.ok) {
      button.closest('.table-like-row')?.remove();
    }

    getLookupPicker('serviceManagerServicePicker')?.refresh();
    getLookupPicker('serviceManagerUserPicker')?.refresh();
  }
};
